export const userTypes = {
	INIT_USER: "INIT_USER",
};
